module.exports = __webpack_public_path__ + "static/media/moodIndigo.b6053525.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/ContactUs/static/images/brands/moodIndigo.jpg
// module id = 67
// module chunks = 1